import * as _ from 'lodash'

const abbreviations = ['mri', 'cat']
const exclude = ['and']

function addSpaceBetweenCamelcase(input) {
  // Only proceed if text has no spaces and has camel casing
  const camelCaseRegex = /^([a-z]|[A-Z])[a-zA-Z0-9]*$/g
  if (input.trim().includes(' ') || !camelCaseRegex.test(input)) {
    return input
  }

  // Create a regex-safe list of exceptions
  const exceptionPattern = abbreviations.map(abbrev => abbrev.toUpperCase()).join('|')

  // Temporarily mark the exception acronyms to avoid splitting them
  const tempReplacer = (match) => ` ${match.toLowerCase()} `
  const protectedInput = input.replace(
    new RegExp(`(${exceptionPattern})`, 'g'),
    tempReplacer,
  )

  // Add space before capital letters (but not the first char)
  const spaced = protectedInput.replace(/(?!^)([A-Z])/g, ' $1')

  return spaced.trim()
}

export function titlecase(text: string): string {
  if (!_.isNil(text)) {
    text = String(text)
  }

  const words = addSpaceBetweenCamelcase(text || '')
    // replace hyphens with spaces
    .replace(/\-/g, ' ')
    // replace underscores with spaces
    .replace(/_/g, ' ')
    // ensure only 1 space between each word
    .replace(/\s+/g, ' ')
    .split(' ')

  // go through each word
  return _.map(words, (word) => {
    if (_.includes(exclude, word)) {
      return word
    }

    if (_.includes(abbreviations, word.toLowerCase())) {
      return word.toUpperCase()
    }

    const firstLetter = word.substr(0, 1).toUpperCase()
    const rest = word.substr(1)
    return firstLetter + rest
  }).join(' ')
}
